// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import type { RootState } from "../store";

// // Define a type for the slice state
// interface weatherState {

//   emp_name: string;
//   emp_designation: string;
//   emp_profile_
// }

// // Define the initial state using that type
// const initialState: weatherState = {

//   emp_name: "",
// };

// export const weatherSlice = createSlice({
//   name: "weather",
//   initialState,
//   reducers: {
//     dashboardWeather: (state: any, action: PayloadAction<weatherState>) => {
//       const payload = action.payload;
//       state.temperature = payload.temperature;
//       state.day = payload.day;
//       state.time = payload.time;
//       state.emp_name = payload.emp_name;
//     },
//     resetWeather: (state: any) => {
//       state.temperature = "";
//       state.day = "";
//       state.time = "";
//       state.emp_name = "";
//     },
//   },
// });

// export const { dashboardWeather, resetWeather } = weatherSlice.actions;

// // // Other code such as selectors can use the imported `RootState` type
// // export const selectCount = (state: RootState) => state.counter.value

// export default weatherSlice.reducer;

export default {};
